import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
} from "@/components/ui/dialog"
import type { TikTokAccountRow, AdNetwork } from "@/api/hooks/admin"

interface NetworkModalProps {
  account: TikTokAccountRow | null
  networks: AdNetwork[]
  selectedNetwork: string
  onSelectNetwork: (slug: string) => void
  onConfirm: () => void
  onClose: () => void
  isPending: boolean
  getNetworkName: (slug: string | null) => string | null
}

export function NetworkModal({
  account,
  networks,
  selectedNetwork,
  onSelectNetwork,
  onConfirm,
  onClose,
  isPending,
  getNetworkName,
}: NetworkModalProps) {
  return (
    <Dialog open={account !== null} onOpenChange={(open) => !open && onClose()}>
      <DialogContent className="max-w-[500px] border-[#4a4a4a] bg-[#3a3a3a] text-white">
        <DialogHeader>
          <DialogTitle>Assign Network</DialogTitle>
          <DialogDescription className="text-white">
            Select a network for this account.
          </DialogDescription>
        </DialogHeader>
        <div className="space-y-4">
          <div>
            <label className="mb-1 block text-sm font-medium">Account</label>
            <div className="rounded-md bg-[#2d2d2d] px-3 py-2">
              <strong>{account?.advertiser_name}</strong>
              <div className="mt-1 text-xs text-white">
                Current: {getNetworkName(account?.network ?? null) ?? "Not assigned"}
              </div>
            </div>
          </div>
          <div>
            <label className="mb-1 block text-sm font-medium">Select Ad Network</label>
            <select
              value={selectedNetwork}
              onChange={(e) => onSelectNetwork(e.target.value)}
              className="w-full rounded-md border border-[#555] bg-[#2d2d2d] px-3 py-2 text-sm text-white"
            >
              <option value="">-- Not assigned --</option>
              {networks.map((n) => (
                <option key={n.id} value={n.slug}>{n.name}</option>
              ))}
            </select>
          </div>
          <div className="flex gap-3 pt-2">
            <button onClick={onConfirm} disabled={isPending}
              className="flex-1 rounded-md border border-[#8fa0ef]/35 bg-[#7488e8] px-4 py-2 font-semibold text-white shadow-sm transition-colors hover:bg-[#687bda] disabled:opacity-50">
              Confirm
            </button>
            <button onClick={onClose}
              className="flex-1 rounded-md border border-[#7a808b]/45 bg-[#636b78] px-4 py-2 font-semibold text-white shadow-sm transition-colors hover:bg-[#58606c]">
              Cancel
            </button>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  )
}
